<div class="box-shadow rounded--large guts-p-full-2 bg-color-white">
  <div class="l_flexbar guts-m-b-1">
    <h1 class="h3 l_flex-grow" [innerHtml]="chartName"></h1>
  </div>
  <div *ngIf="!results.length" class="center-text guts-m-v-2-half">
    <span
      [attr.aria-label]="i18n.SkillSectionsChart_Team_NoRatings"
      [textContent]="i18n.SkillSectionsChart_Team_NoRatings"
    ></span>
  </div>
  <div
    *ngFor="let skill of results; first as isFirst"
    [ngClass]="{ 'border-top': !isFirst }"
    class="guts-p-v-3"
    data-dgat="flexSkillSectionsChart-5ac"
  >
    <div class="l_flex">
      <div class="guts-p-r-half l_flex-one">
        <h3
          class="font-medium guts-p-b-half"
          [innerHtml]="
            skill.tag.title.length < 60
              ? skill.tag.title
              : skill.tag.title.substring(0, 60) + '...'
          "
        ></h3>
        <div *ngIf="!skill.tagRatings" class="center-text guts-m-v-2-half">
          <span
            [attr.aria-label]="i18n.SkillSectionsChart_Team_NoRatings"
            [textContent]="i18n.SkillSectionsChart_Team_NoRatings"
          ></span>
        </div>
        <section *ngIf="skill.tagRatings">
          <div
            class="par par--small par--light guts-p-b-0"
            [innerHTML]="getFollowFormat(skill)"
          ></div>
          <div
            class="par par--small par--light guts-p-b-0"
            [innerHTML]="getRatingFormat(skill)"
          ></div>
          <div
            class="par par--small par--light guts-p-b-0"
            [innerHTML]="getAverageRatingFormat(skill)"
          ></div>
        </section>
      </div>
      <div
        *ngIf="skill.tagRatings"
        id="graphContainer{{ skill.GUID }}"
        class="vbargraph skillgraph"
      ></div>
    </div>
  </div>
</div>
